import * as React from "react";
const SvgClappingHands = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.17 1.898a.754.754 0 0 1 .063-.04L15.598.514a2.243 2.243 0 0 1 3.042.81c.345.322.583.746.676 1.209a2.25 2.25 0 0 1 2.579 2.819l-.507 1.809a2.25 2.25 0 0 1 2.317 2.852l-2.426 8.666-.003.008c-1.109 3.944-5.612 5.95-9.896 4.75-2.759-.772-4.905-2.727-5.79-5.074-1.681-.724-3.187-2.05-4.196-3.844-2.047-3.64-1.398-8.137 1.641-10.34a.749.749 0 0 1 .197-.16l.41-.23.026-.015L8.895.833a2.253 2.253 0 0 1 3.32 1.55 2.26 2.26 0 0 1 .956-.485Zm-2.057 2.858.053-.031-.698 2.493a2.25 2.25 0 0 0-3.46 1.235L5.39 14.23a6.476 6.476 0 0 0-.226 2.207 7.596 7.596 0 0 1-2.463-2.654c-1.873-3.331-.986-7.172 1.68-8.69l5.25-2.953a.753.753 0 0 1 .74 1.312L7.687 4.979a.75.75 0 1 0 .742 1.304l2.685-1.527Zm1.518 8.646a.749.749 0 0 0 .925-.52l2.83-10.112a.75.75 0 1 1 1.445.405l-.262.936-.008.027L15 13.286a.75.75 0 0 0 1.445.405l2.565-9.164a.75.75 0 0 1 1.44.42l-2.561 9.148a.75.75 0 1 0 1.444.404l.178-.635.002-.007 1.303-4.654a.75.75 0 0 1 1.445.404l-2.427 8.667c-.83 2.964-4.36 4.75-8.05 3.717-3.684-1.031-5.772-4.38-4.954-7.34l.004-.017 1.618-5.777a.75.75 0 0 1 1.448.39l-.678 2.421a.75.75 0 1 0 1.445.405l.674-2.408.006-.023 1.611-5.754a.75.75 0 0 1 1.445.404l-2.292 8.185a.75.75 0 0 0 .52.925Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgClappingHands;
